module["exports"] = [
  "Bazza",
  "Bluey",
  "Davo",
  "Johno",
  "Shano",
  "Shazza"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en_au_ocker/name/ocker_first_name.js
// module id = 427
// module chunks = 0